// import "./saved.css"

import { Outlet } from "react-router-dom"

// import { useContext } from "react"
// import { CartContext } from "../../../../../contexts/cartContext"

import UserDashTransNav from '../../../components/dashNavbar/userDashTransNav'

export default function UserTransOut() {
    
  return (
    <div className="savedItems">
        {/* <UserDashNavbar/>*/}
        <UserDashTransNav/> 
   
        <Outlet/>
    </div>
  )
}
